import axios from 'axios';
import * as Config from '../../config';
import { setToken, getToken, removeToken } from '../../utils/tokenStorage';

const state = {
    token: '',
    status: '',
    me: '',
    study: '',
    client: {},
    permissions: [],
    resetAuth: false
};

const getters = {
    admin: state => state.me,
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
    token: state => state.token,
    resetAuth: state => state.resetAuth,
};

const actions = {
    async initAuth({ commit }) {
        const accessToken = await getToken();
        //console.log('accessToken:',accessToken);
        if (accessToken) {
            commit('SET_TOKEN', accessToken);
        }
    },

    async logout({ commit }) {
        commit('RESET_STATE');
        await removeToken();
        return { code: 200, message: 'Salida Exitosa!' };
    },

    async checkLoginSpa({ commit }) {
        const accessToken = await getToken();
        console.log('accessToken: ', accessToken);
        if (!accessToken) {
            commit('CHECK_LOGIN_FAIL');
            throw new Error('No access token stored');
        }
        return true;
    },

    // ADMIN
    async login({ commit }, form) {
        return axios.post(Config.apiPath + 'auth/admin/login', form)
            .then(async response => {
                if (response.data.code === 200) {
                    const accessToken = response.data.access_token;
                    await setToken(accessToken);
                    commit('RESET_STATE');
                    commit('LOGIN_OK', response.data);
                    return response.data;
                } else {
                    commit('LOGIN_FAIL');
                    throw response.data;
                }
            })
            .catch(error => {
                commit('LOGIN_FAIL');
                throw error.response?.data || error;
            });
    },

    async register({ commit }, form) {
        commit('REGISTER');
        return axios.post(Config.apiPath + 'auth/signup', form)
            .then(response => response.data)
            .catch(error => {
                commit('REGISTER_FAIL');
                throw error.response?.data || error;
            });
    },

    async verify_email({ commit }, hash) {
        commit('REGISTER');
        return axios.get(Config.apiPath + 'auth/verify/email/' + hash)
            .then(response => {
                commit('REGISTER_FAIL');
                return response.data;
            })
            .catch(error => {
                commit('REGISTER_FAIL');
                throw error.response?.data || error;
            });
    },

    async changeImg({ commit }, form) {
        commit('UPDATE_PROFILE');
        return axios.post(Config.apiPath + 'user/change_image', form, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
            .then(response => {
                commit('UPDATE_PROFILE_OK', response.data.data);
                return response.data;
            })
            .catch(error => {
                commit('UPDATE_PROFILE_FAIL');
                throw error.response?.data || error;
            });
    },

    async updateProfile({ commit }, form) {
        commit('UPDATE_PROFILE');
        return axios.post(Config.apiPath + 'user/update_profile', form)
            .then(response => {
                commit('UPDATE_PROFILE_OK', response.data.data);
                return response.data;
            })
            .catch(error => {
                commit('UPDATE_PROFILE_FAIL');
                throw error.response?.data || error;
            });
    },

    async updatePassword({ commit }, form) {
        commit('UPDATE_PASSWORD');
        return axios.post(Config.apiPath + 'user/update_password', form)
            .then(async response => {
                await removeToken();
                commit('UPDATE_PASSWORD_OK', response.data);
                return response.data;
            })
            .catch(error => {
                commit('UPDATE_PASSWORD_FAIL');
                throw error.response?.data || error;
            });
    },

    // Mono
    async loginClient({ commit }, form) {
        return axios.post(Config.apiPath + 'auth/client/login', form)
            .then(async response => {
                if (response.data.code === 200) {
                    const accessToken = response.data.access_token;
                    console.log('accessToken', accessToken);
                    await setToken(accessToken);
                    commit('MONO_LOGIN_OK', response.data);
                    return response;
                } else {
                    commit('LOGIN_FAIL');
                    return response.data;
                }
            })
            .catch(error => {
                commit('LOGIN_FAIL');
                throw error.response?.data || error;
            });
    },


    async registerClient({ commit }, form) {
        return axios.post(Config.apiPath + 'auth/client/register', form)
            .then(response => {
                if (response.data.code === 200) return response.data;
                throw response.data;
            })
            .catch(error => {
                commit('LOGIN_FAIL');
                throw error.response?.data || error;
            });
    },

    async delegate_afip(_, form) {
        return axios.post(Config.apiPath + 'mono/delegate-afip', form)
            .then(response => {
                if (response.data.code === 200) return response.data;
                throw response.data;
            })
            .catch(error => {
                throw error.response?.data || error;
            });
    },

    async loginStudy({ commit }, form) {
        return axios.post(Config.apiPath + 'auth/study/login', form)
            .then(async response => {
                if (response.data.code === 200) {
                    const accessToken = response.data.access_token;
                    await setToken(accessToken);
                    commit('RESET_STATE');
                    commit('STUDY_LOGIN_OK', response.data);
                    return response.data;
                } else {
                    commit('LOGIN_FAIL');
                    throw response.data;
                }
            })
            .catch(error => {
                commit('LOGIN_FAIL');
                throw error.response?.data || error;
            });
    },

    async auth_getClientChat({ commit }, form) {
        return axios.post(Config.apiPath + 'auth/get-client-chat', form)
            .then(response => {
                commit('SET_CHAT', response.data.chat);
                return response;
            })
            .catch(error => {
                throw error.response?.data || error;
            });
    },

    async auth_verifyCaptcha(_, form) {
        return axios.post(Config.apiPath + 'auth/verify-captcha', form)
            .then(response => response)
            .catch(error => {
                throw error.response?.data || error;
            });
    },

    async auth_reloadUser({ commit }, form) {
        return axios.post(Config.apiPath + 'auth/reload-user', form)
            .then(response => {
                commit('RELOAD_USER', response.data);
            })
            .catch(error => {
                throw error.response?.data || error;
            });
    },

    setDateGetBalance({ commit }, dateGetBalance) { commit('SET_DATE_GET_BALANCE', dateGetBalance); },
    setAdmin({ commit }) { commit('SET_PERMISSION_ADMIN'); },
    setStudy({ commit }, data) { commit('SET_PERMISSION_STUDY', data); },
    setMono({ commit }, data) { commit('SET_PERMISSION_MONO', data); },
    setLoginMono({ commit }, data) { commit('MONO_LOGIN_OK', data); },
    setDateGetInvoice({ commit }, data) { commit('SET_GET_DATE_INVOICE', data); }
};

const mutations = {
    LOGIN(state) { state.status = 'loading'; },
    LOGIN_OK(state, data) {
        state.me = data.user;
        state.permissions = data.permissions;
        state.token = data.access_token;
        state.status = 'success';
    },
    STUDY_LOGIN_OK(state, data) {
        state.study = data.user;
        state.permissions = data.permissions;
        state.token = data.access_token;
        state.status = 'success';
    },
    RELOAD_USER(state, data) {
        state.client = data.user;
    },
    MONO_LOGIN_OK(state, data) {
        state.client = data.user;
        state.permissions = data.permissions;
        state.token = data.access_token;
        state.status = 'success';
    },
    LOGOUT_OK(state) {
        state.me = '';
        state.study = '';
        state.client = '';
        state.permissions = [];
        state.token = '';
        state.status = 'error';
    },
    LOGIN_FAIL(state) {
        state.me = '';
        state.study = '';
        state.permissions = [];
        state.token = null;
        state.status = 'error';
        state.resetAuth = false;
        state.client = {};
    },
    CHECK_LOGIN_FAIL(state) {
        state.client = {};
        state.me = '';
        state.study = '';
        state.permissions = [];
        state.token = null;
        state.status = 'error';
    },
    REGISTER_OK(state, user) { state.me = user; },
    UPDATE_PROFILE_OK(state, user) { state.me = user; },
    SET_PERMISSION_ADMIN() { },
    SET_PERMISSION_STUDY(state, data) { state.study = data; },
    SET_PERMISSION_MONO(state, data) { state.client = data; },
    RESET_STATE(state) {
        state.token = '';
        state.status = '';
        state.me = '';
        state.study = '';
        state.client = {};
        state.permissions = [];
        state.status = 'success';
    },
    SET_GET_DATE_INVOICE(state, data) { state.client.date_get_invoice = data; },
    SET_CHAT(state, chat) { state.client.chat = chat; },
    SET_TOKEN(state, token) { state.token = token; },
    SET_DATE_GET_BALANCE(state, dateGetBalance) {
        state.client.date_get_balance = dateGetBalance;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
